//npm run dev => Builds dev code
//npm run prod => Builds prod code (previously you changed production: to true)

const devOptions = {
  shortHubUrl: "nwea-migration.ufcontent.com/", //change me to the base url of your hub (no http(s) or www)
  fullHubUrl: "http://nwea-migration.ufcontent.com/" + "?onbrand", //exact url to access hub, leave onbrand query string
  cihostFolder: "nwea-v3", //change me to the cihost folder name
  remindMeToGit: true,
  notifyOnBuildSuccess: true //Gives a (slightly annoying?) message whenever a build completes successfully
};

module.exports = devOptions;



// WEBPACK FOOTER //
// ./dev-options.js